import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";

const ProfileContext = createContext(null);
const KEY = "velyrea_profile";
const KEY_S = "velyrea_season";

export function ProfileProvider({ children }) {
  const [profile, setProfileState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
  });
  const [season, setSeason] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY_S)) || null; } catch { return null; }
  });
  const [options, setOptions] = useState(null);

  useEffect(() => {
    api.get("/options").then(({ data }) => setOptions(data)).catch(() => {});
  }, []);

  const setProfile = useCallback((p) => {
    setProfileState(p);
    localStorage.setItem(KEY, JSON.stringify(p));
  }, []);

  const analyze = useCallback(async (p) => {
    const { data } = await api.post("/analyze", p);
    setSeason(data.season);
    localStorage.setItem(KEY_S, JSON.stringify(data.season));
    return data.season;
  }, []);

  const hasProfile = profile && Object.keys(profile).length >= 3;

  return (
    <ProfileContext.Provider value={{ profile, setProfile, season, setSeason, analyze, options, hasProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => useContext(ProfileContext);
